import React, { FC, Children, useCallback, useEffect, useState } from 'react'

const RestaurantSearchBar: FC = () => {
  return <div>filter and search bar</div>
}

export default RestaurantSearchBar
